import TemplateView from "../../TemplateView"
import {CustomCheckBoxSize} from './constants'

export default class CustomCheckbox extends TemplateView {

    constructor({
        label = "",
        htmlLabel = "",
        checked = false,
        onChange = () => {},
        containerAdditionalClass = "",
        checkboxAdditionalClass = "",
        checkmarkAdditionalClass = "",
        checkboxTitleAdditionalClass = "",
        tabindex = 0,
        size = CustomCheckBoxSize.DEFAULT,
    }) {
        super()

        this.props = {
            label,
            onChange,
            containerAdditionalClass,
            checkboxAdditionalClass,
            checkmarkAdditionalClass,
            checkboxTitleAdditionalClass,
            tabindex,
            size,
        }
        this.state = {
            label,
            htmlLabel,
            checked,
            disabled: false,
            indeterminate: false
        }

        this.onStatePropertyChanged("checked", checked => {
            this.getEl().toggleClass("checked", checked)
            this.checkbox.prop("checked", checked)
        })
        this.onStatePropertyChanged("disabled", disabled => {
            this.getEl().toggleClass('disabled', disabled)
            this.checkbox.prop("disabled", disabled)
        })
        this.onStatePropertyChanged("indeterminate", indeterminate => this.$el.toggleClass("indeterminate", indeterminate))
        this.onStatePropertyChanged("label", label => this._updateLabel(label))
        this.onStatePropertyChanged("htmlLabel", htmlLabel => this._updateHtmlLabel(htmlLabel))
    }

    templateHtml() {
        return "<label class='components_checkboxContainer <%-containerClass%>'>" +
               "  <span class='label <%-titleClass%>'></span>" +
               "  <input type='checkbox' class='checkbox <%-checkboxClass%>' tabindex='<%-tabindex%>'>" +
               "  <span class='checkmark <%-checkmarkClass%>'></span>" +
               "</label>"
    }

    templateModel() {
        return {
            containerClass: this.props.containerAdditionalClass,
            checkboxClass: this.props.checkboxAdditionalClass,
            checkmarkClass: this.props.checkmarkAdditionalClass,
            titleClass: this.props.checkboxTitleAdditionalClass,
            tabindex: this.props.tabindex
        }
    }

    afterRender() {
        this.checkbox = this.$el.find('.checkbox')
        this.checkmark = this.$el.find('.checkmark')

        this.$el.on('click', (e) => {
            e.stopPropagation()
        })

        this.checkbox.on('click', (e) => {
            e.stopPropagation()

            const checked = !this.state.checked
            this.setState({
                checked
            })
            if (this.props.onChange) {
                this.props.onChange({
                    checked: checked,
                    disabled: this.state.disabled
                }, e)
            }
        })

        this.getEl().toggleClass('little', this.props.size === CustomCheckBoxSize.LITTLE)

        this.renderInitialState()
    }

    isChecked() {
        return this.checkbox[0].checked || false
    }

    _updateLabel(label) {
        !this.state.htmlLabel && this.find('.label').text(label)
    }

    _updateHtmlLabel(htmlLabel) {
        !this.state.label && this.find('.label').html(htmlLabel)
    }
}


// WEBPACK FOOTER //
// ./web/js/components/customCheckbox/CustomCheckbox.js